var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item"},[_c('router-link',{attrs:{"to":{ name: 'chats' }}},[_c('message-notif-icon')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }